export default ('Proxy' in window);


// WEBPACK FOOTER //
// ./src/util/hasProxy.js